module.exports = __webpack_public_path__ + "img/logo-white.45d2122a.png";